import { useTranslation } from "react-i18next";
import AnimatedElement from "../AnimatedElement";

import "../../i18next";
import nosotros from "../../assets/images/Nosotros/IMG_1370.JPG";

function Nosotros3() {
  const { t } = useTranslation();

  return (
    <section className="relative md:pt-32 pb-20 px-4 bg-gradient-to-b from-white to-[#9B9DB6]">
      {/* Contenedor Principal Responsive */}
      <div className="flex flex-col lg:flex-row items-start justify-center gap-10 max-w-7xl mx-auto">
        {/* Imagen */}
        <AnimatedElement
          fromDirection="bottom"
          className="w-full lg:w-1/3 flex justify-center"
        >
          <img
            src={nosotros}
            alt="Nosotros"
            className="object-contain w-full  h-96"
          />
        </AnimatedElement>

        {/* Textos y datos */}
        <div className="flex flex-col w-full lg:w-2/3 gap-10 mt-10 lg:mt-0">
          {/* Título grande */}
          <AnimatedElement
            fromDirection="left"
            className="text-orangeAtm text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold"
            style={{ fontFamily: "Helvetica" }}
          >
            {t("aboutUs.subtitle1")}
          </AnimatedElement>

          {/* Texto central */}
          <AnimatedElement
            fromDirection="bottom"
            className="text-base sm:text-lg md:text-xl lg:text-2xl font-medium text-center lg:text-left text-customDarkBlue"
            style={{ fontFamily: "Helvetica" }}
          >
            {t("aboutUs.textbetween")}
          </AnimatedElement>

          {/* Bloque de estadísticas */}
          <AnimatedElement fromDirection="right">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 text-white">
              {[
                {
                  number: "+2.000",
                  text: `${t("aboutUs.innovatedSolutions")} \n ${t(
                    "aboutUs.selfServiceInstalled"
                  )}`,
                },
                {
                  number: "+7.000",
                  text: `${t("aboutUs.operating")} \n ${t("aboutUs.atms")}`,
                },
                {
                  number: "+2.000",
                  text: `${t("aboutUs.associated")} \n ${t(
                    "aboutUs.reliable"
                  )}`,
                },
              ].map((item, index) => (
                <div key={index} className="flex items-start gap-4">
                  <div className="border-l-4 border-customDarkBlue h-24"></div>
                  <div>
                    <div className="text-orange-500 text-3xl sm:text-4xl lg:text-6xl font-bold leading-tight">
                      {item.number}
                    </div>
                    <p
                      className="text-sm sm:text-base md:text-lg lg:text-xl font-medium text-customDarkBlue whitespace-pre-line"
                      style={{ fontFamily: "Helvetica" }}
                    >
                      {item.text}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </AnimatedElement>
        </div>
      </div>
    </section>
  );
}

export default Nosotros3;
